(function(){
  const T = window.MonasTheme || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} TL';
    const fmt = (n, d, ts, ds) => {
      d = d == null ? 2 : d; ts = ts || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(d);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (parts[1] ? ds + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }
  window.MonasTheme.formatMoney = formatMoney;

  /* ---------- shipping bars ---------- */
  function updateShipBars(total) {
    const th = T.freeShipping || 0;
    $$('[data-ship-bar]').forEach(bar => {
      if (!th) return;
      const left = th - total;
      const msg = $('[data-ship-msg]', bar), fill = $('[data-ship-fill]', bar);
      if (msg) msg.innerHTML = left > 0 ? bar.dataset.text.replace('[tutar]', '<strong>' + formatMoney(left) + '</strong>') : bar.dataset.success;
      if (fill) fill.style.width = Math.min(100, total / th * 100) + '%';
    });
  }
  function updateCount(n) { $$('[data-cart-count]').forEach(el => el.textContent = n); }

  /* ---------- cart drawer ---------- */
  const SECTION = 'cart-drawer';
  function openDrawer() { if (!$('#CartDrawer')) return false; document.body.classList.add('drawer-open'); setTimeout(() => { const c = $('#CartDrawer .icon-btn'); c && c.focus(); }, 50); return true; }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-drawer-inner]'), cur = $('[data-drawer-inner]');
    if (next && cur) cur.replaceWith(next);
  }
  async function refreshCart() {
    const cart = await fetch(T.routes.cart + '.js').then(r => r.json());
    updateCount(cart.item_count); updateShipBars(cart.total_price);
    return cart;
  }
  async function changeLine(line, quantity) {
    const d = $('#CartDrawer'); d && d.classList.add('is-loading');
    const res = await fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: SECTION, sections_url: location.pathname }) }).then(r => r.json());
    if (res.sections) renderDrawer(res.sections[SECTION]);
    updateCount(res.item_count); updateShipBars(res.total_price);
    d && d.classList.remove('is-loading');
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-cart-open]');
    if (t && T.cartType === 'drawer' && openDrawer()) { e.preventDefault(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    const q = e.target.closest('[data-qty-change]');
    if (q && q.closest('#CartDrawer')) { e.preventDefault(); changeLine(+q.dataset.line, Math.max(0, +q.dataset.qtyChange)); return; }
    const pq = e.target.closest('[data-qty-step]');
    if (pq) { const inp = pq.parentElement.querySelector('input'); inp.value = Math.max(1, (+inp.value || 1) + (+pq.dataset.qtyStep)); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closePopup(); } });

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-product-form]');
    if (!form || T.cartType !== 'drawer' || !$('#CartDrawer')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]'); btn && btn.setAttribute('aria-busy', 'true');
    const fd = new FormData(form); fd.append('sections', SECTION); fd.append('sections_url', location.pathname);
    try {
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.json());
      if (res.status) { alert(res.description || res.message); return; }
      if (res.sections) renderDrawer(res.sections[SECTION]);
      await refreshCart(); openDrawer();
    } finally { btn && btn.removeAttribute('aria-busy'); }
  });

  // gift note → cart note
  let noteTimer;
  document.addEventListener('input', e => {
    if (e.target.matches('[data-cart-note]')) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }), 500);
    }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-note-toggle]')) { const w = $('[data-note-wrap]'); if (w) w.hidden = !e.target.checked; }
    if (e.target.matches('[data-tag-select]')) { location.href = e.target.value; return; }
    if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); }
  });

  /* ---------- mobile nav ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-nav-toggle]'); if (!b) return;
    const nav = $('#HeaderNav'); if (!nav) return;
    const open = nav.classList.toggle('is-open'); b.setAttribute('aria-expanded', open);
  });

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(g => {
    const slides = $$('.pgallery__slide', g), thumbs = $$('.pgallery__thumb', g);
    let i = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    const go = n => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    const p = $('[data-prev]', g), n = $('[data-next]', g);
    p && p.addEventListener('click', () => go(i - 1)); n && n.addEventListener('click', () => go(i + 1));
    g._goToMedia = id => { const k = slides.findIndex(s => s.dataset.mediaId == id); if (k > -1) go(k); };
  });

  /* ---------- variant picker ---------- */
  $$('[data-product]').forEach(root => {
    const json = $('[data-product-json]', root); if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('[data-product-form]', root), idInput = form && form.querySelector('[name=id]');
    root.addEventListener('change', e => {
      if (!e.target.closest('[data-variant-picker]')) return;
      const opts = $$('[data-variant-picker] fieldset', root).map(fs => (fs.querySelector('input:checked') || {}).value);
      const v = product.variants.find(v => v.options.every((o, k) => o === opts[k]));
      const btn = form && form.querySelector('[type=submit]');
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Mevcut değil'; } return; }
      if (idInput) idInput.value = v.id;
      $$('[data-price]', root).forEach(el => el.textContent = formatMoney(v.price));
      $$('[data-compare]', root).forEach(el => { el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; });
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Tükendi'; }
      if (v.featured_media) { const g = $('[data-gallery]', root); g && g._goToMedia && g._goToMedia(v.featured_media.id); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
    });
  });

  /* ---------- recommendations ---------- */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const html = await fetch(el.dataset.url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true);
    } catch (e) {}
  });

  /* ---------- marketing popup ---------- */
  const popup = $('#MarketingPopup');
  const KEY = 'monas-popup-dismissed';
  function openPopup() { if (!popup) return; popup.hidden = false; document.body.classList.add('popup-open'); }
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true; document.body.classList.remove('popup-open');
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  if (popup) {
    popup.addEventListener('click', e => { if (e.target.closest('[data-popup-close]')) closePopup(); });
    const posted = /customer_posted=true/.test(location.search) || location.hash === '#PopupForm' || $('[data-popup-success]', popup);
    const design = popup.dataset.design === 'true';
    let last = 0; try { last = +localStorage.getItem(KEY) || 0; } catch (e) {}
    const days = +popup.dataset.days || 0;
    const expired = !last || (days > 0 && Date.now() - last > days * 864e5);
    if (posted && $('[data-popup-success]', popup)) openPopup();
    else if (design) { if (!sessionStorage.getItem('monas-popup-design')) { sessionStorage.setItem('monas-popup-design', '1'); openPopup(); } }
    else if (expired) setTimeout(openPopup, (+popup.dataset.delay || 0) * 1000);
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', () => {});
    }
  }
})();
